var cov_1ri4jj2pa7 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/styles/index.js",
      hash = "4a0b9de24d3c334f4ff22a48a2f11cf4f51e7197",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      },
      "1": {
        start: {
          line: 6,
          column: 32
        },
        end: {
          line: 6,
          column: 67
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var formLess = {};
import genaration from '../../utils/classname';
export var formClass = (cov_1ri4jj2pa7.s[0]++, genaration(formLess, 'form'));
export var inputBorderClass = (cov_1ri4jj2pa7.s[1]++, genaration(formLess, 'inputBorder'));